<template>
	<div class="">
		<div class="elastic-layer-box" v-if="isShowBox">
			 <div class="elastic-layer">
			 	    <div class="laylerimgs" @click="closeFun">
			 	    	<img :src="imgs" alt="" />
			 	    </div>
					<div class="" style="clear: both;">
						
					</div>
					<div class="phone-zx">
						电话咨询热线
					</div>
					<div class="phoneText">
						400-1606-202
					</div>
					<div class="our-serves">
						让我们为您提供更多贴心服务！
					</div>
					<div class="online-time">
						在线时间：9:00~18:00
					</div>
					<div class="bottem-border">
						期待您的来电
					</div>
			 </div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				imgs:require("../assets/home/sy_tc1.png"),
			}
		},
		
		props:{
			isShowBox:Boolean,
			default:false
		},
		methods:{
			closeFun(){
				this.$emit('closeFun')
			}
		}
	}
</script>

<style lang="scss" scoped>
	.elastic-layer-box{
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5);
		position: fixed;
		top: 0;
		left: 0;
		.elastic-layer{
			width: 400px;
			height: 290px;
			background-color: #fff;
			border-radius: 30rpx;
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			.laylerimgs{
				width: 44px;
				height: 44px;
				// display: flex;
				float: right;
			}
			.phone-zx{
				font-size: 20px;
				font-weight: bold;
				color:#333;
				text-align: center;
			}
			.phoneText{
				font-size: 20px;
				color:#ffba00;
				font-weight: bold;
				margin: 24px;
				text-align: center;
			}
			.our-serves{
				text-align: center;
				margin:0 0 12px;
				font-size: 14px;
				color:#999
			}
			.online-time{
				text-align: center;
				margin:12px 0 32px;
				font-size: 14px;
				color:#999
			}
			.bottem-border{
				width: 128px;
				height: 32px;
				border: 1px solid #ffba00;
				line-height: 32px;
				color:#ffba00;
				font-size: 14px;
				background-color: #fff;
				text-align: center;
				margin: 0 auto;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/contactList.vue